"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatActions = exports.AgentType = exports.ChatQuality = exports.ChatStatus = void 0;
var ChatStatus;
(function (ChatStatus) {
    ChatStatus["ACTIVE"] = "ACTIVE";
    ChatStatus["CLOSED"] = "CLOSED";
})(ChatStatus || (exports.ChatStatus = ChatStatus = {}));
var ChatQuality;
(function (ChatQuality) {
    ChatQuality["DEFAULT"] = "DEFAULT";
    ChatQuality["HIGH"] = "HIGH";
    ChatQuality["LOW"] = "LOW";
})(ChatQuality || (exports.ChatQuality = ChatQuality = {}));
var AgentType;
(function (AgentType) {
    AgentType["BOT"] = "BOT";
    AgentType["AGENT"] = "AGENT";
})(AgentType || (exports.AgentType = AgentType = {}));
var ChatActions;
(function (ChatActions) {
    ChatActions["RESET_PASSWORD_CONFIRMATION"] = "resetPasswordConfirmation";
    ChatActions["RESET_PASSWORD_SENT"] = "resetPasswordSent";
    ChatActions["RESET_OR_OTP_LOGIN_OPTIONS"] = "resetOrOtpLoginOptions";
    ChatActions["OTP_LOGIN"] = "otpLogin";
    ChatActions["RESET_PASSWORD_REQUEST_EMAIL"] = "resetPasswordRequestEmail";
    ChatActions["UNSUPPORTED_ACTION"] = "unsupportedAction";
    ChatActions["RESEND_CONFIRMATION_EMAIL"] = "resendConfirmationEmail";
    ChatActions["CONFIRM_RESEND_CONFIRMATION_EMAIL"] = "confirmResendConfirmationEmail";
    ChatActions["LIST_ACTIONS"] = "listActions";
    ChatActions["LIST_ORDERS"] = "listOrders";
    ChatActions["LIST_FAQ"] = "listFAQ";
    ChatActions["SELECT_ORDER"] = "selectOrder";
    ChatActions["LIST_ORDER_ACTIONS"] = "listOrderActions";
    ChatActions["CANCEL_ORDER"] = "cancelOrder";
    ChatActions["MANAGE_BOOKING"] = "manageBooking";
    ChatActions["REQUEST_AGENT"] = "requestAgent";
    ChatActions["SHOW_FINE_PRINT"] = "showFinePrint";
    ChatActions["CHANGE_ROOM"] = "changeRoom";
    ChatActions["CHANGE_DATES"] = "changeDates";
    ChatActions["LIST_INCLUSIONS"] = "listInclusions";
    ChatActions["LIST_ORDER_ITEMS"] = "listOrderItems";
    ChatActions["SELECT_ORDER_ITEM"] = "selectOrderItem";
    ChatActions["LIST_DEFAULT_ACTIONS"] = "listDefaultActions";
})(ChatActions || (exports.ChatActions = ChatActions = {}));
